// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.7304 21.6641L13.4456 22.2358L17.15 13.9V2H6.51631C5.0356 2 3.77635 3.08034 3.5512 4.54383L2.36658 12.2438C2.087 14.0611 3.49304 15.7 5.3317 15.7H9.20047V18.154C9.20047 19.7465 10.2196 21.1605 11.7304 21.6641Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.0004 13.9V2H19.1504L19.1508 13.9H22.0004Z"}}]};

const ThumbDown2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'thumb-down-2-filled',
    ref,
    icon: element,
  },
));

ThumbDown2FilledIcon.displayName = 'ThumbDown2FilledIcon';

export default ThumbDown2FilledIcon;
